<template>
	<div>
		<div class="mb-2">
      <img :src="data.cover_image_url" class="img-fit radius-6 w-100" style="height:150px !important;">
		</div>
		<p class="body-1-4 mb-0 text-truncate text-16">{{data.name}}</p>
		<p class="body-3 mb-0 w-100">{{$t('hotel.starting-from')}}</p>
		<p 
			v-if="is_decrease_promo" 
			class="mb-0 text-line-through body-3 d-inline-block align-middle text-15 mr-1">
			{{$formatCurrency(promotion_price)}}
		</p>
		<p 
			class="mb-0 body-1-4 text-orange d-inline-block align-middle text-15"
			:class="{
				'd-inline-block align-middle': is_decrease_promo
			}"
			>
			{{$formatCurrency(final_price)}}
		</p>
	</div>
</template>
<script>
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'

	export default{
		props:['type','data'],
		data(){
			return{
				voucherSliderOption: {
          initialIndex: 0,
          autoPlay: false,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
			}
		},
		components:{
			Flickity
		},
		computed:{
			...mapGetters(['getMerchant']),
			is_variant(){
        return this.data.variant_list.length == 0 ? false : true
      },
      base_price(){
        return this.data.price
      },
      final_price(){
        return calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        if(this.data.price.promotion_amount == 0){
          return 0
        }else{
          return this.data.price.tax_service_calculation_type == 'INCLUDE' ? this.data.price.price_sell_base : this.data.price.price_sell
        }
      },
      is_decrease_promo(){
        if(this.data.price.promotion_amount == 0){
          return false
        }else{
          return this.data.price.promotion_type == 'INCREASE' ? false : true
        }
      },
		},
		mounted(){
		},
		methods:{
			goToDetail(){
				this.$postLog('HOME','MODULE PREVIEW',`Clicked detail ${this.data.upselling_product_group.code}`)
				this.$router.push(`/${this.getMerchant.code}/upselling/${this.data.upselling_product_group.id}`)
			}
		}
	}
</script>
<style>
	.product-small{
		width:100px;
		height:100px;
	}
	.product-small-wrapper{
		width:100px;
	}
	.product-big{
		width:230px;
		height:164px;
	}
	.product-big-wrapper{
		width:230px;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/general/VoucherItem.vue